export const scroll = `
 /* Chrome, Safari and Opera */
  *::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  *::-webkit-scrollbar-thumb {
    background: transparent;
  }
  *::-webkit-scrollbar-corner {
    background: transparent;
  }
  *::-webkit-resizer {
    display: none;
  }

  /* Firefox */
  * {
    scrollbar-width: none;
    scrollbar-color: transparent transparent;
    -ms-overflow-style: none;
  }
`;
